const STASH_KEY = 'samlBridgeBack'
const RELAY_KEY = 'samlBridgeRelay'
const ORIGINS_KEY = 'samlBridgeOrigins'
const STASH_TTL_MS = 10 * 60 * 1000
const RELAY_LOOP_MS = 30 * 1000
// The IdP rejects an AuthnRequest older than 90s.
const SSO_REQUEST_TTL_MS = 80 * 1000
const CLEAR_TIMEOUT_MS = 3000

const readJSON = (key) => {
  try {
    return JSON.parse(sessionStorage.getItem(key)) || {}
  } catch (e) {
    return {}
  }
}

const writeJSON = (key, value) => {
  try {
    sessionStorage.setItem(key, JSON.stringify(value))
  } catch (e) {}
}

export const tokenExpired = (token) => {
  try {
    const claims = JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')))
    const exp = claims?.exp
    if (!exp) return false
    return typeof exp === 'number' ? exp * 1000 < Date.now() : new Date(exp).getTime() < Date.now()
  } catch (e) {
    return false
  }
}

const isSamlHost = (hostname, controller) => {
  const suffix = '.saml.' + String(controller).toLowerCase()
  const label = hostname.slice(0, -suffix.length)
  return hostname.endsWith(suffix) && !!label && !label.includes('.')
}

export const isValidBack = (back, controllers = []) => {
  try {
    if (!back || back.includes('\\')) return false
    const u = new URL(back)
    return (
      u.protocol === 'https:' &&
      !u.username &&
      !u.password &&
      (u.port === '' || u.port === '8643') &&
      (u.pathname === '/sso' || u.pathname === '/saml/application') &&
      controllers.some((c) => !!c && isSamlHost(u.hostname, c))
    )
  } catch (e) {
    return false
  }
}

export const stashBack = (back, now = Date.now()) => writeJSON(STASH_KEY, { back, at: now })

export const takeBack = (now = Date.now()) => {
  const { back, at } = readJSON(STASH_KEY)
  try {
    sessionStorage.removeItem(STASH_KEY)
  } catch (e) {}
  return typeof back === 'string' && now - at >= 0 && now - at < STASH_TTL_MS ? { back, at } : null
}

export const resumeURL = ({ back, at }) =>
  '/ui/saml-bridge?' + new URLSearchParams({ back, resumed: String(at) }).toString()

export const markRelayed = (back, now = Date.now()) => writeJSON(RELAY_KEY, { back, at: now })

export const relayedRecently = (back, now = Date.now()) => {
  const { back: last, at } = readJSON(RELAY_KEY)
  return last === back && now - at < RELAY_LOOP_MS
}

export const ssoRequestExpired = (back, stashedAt, now = Date.now()) => {
  try {
    return !!stashedAt && new URL(back).pathname === '/sso' && now - stashedAt > SSO_REQUEST_TTL_MS
  } catch (e) {
    return false
  }
}

const bridgedOrigins = () => {
  try {
    const origins = JSON.parse(localStorage.getItem(ORIGINS_KEY))
    return Array.isArray(origins) ? origins : []
  } catch (e) {
    return []
  }
}

export const rememberBridged = (origin) => {
  const origins = bridgedOrigins()
  if (origins.includes(origin)) return
  try {
    localStorage.setItem(ORIGINS_KEY, JSON.stringify([...origins, origin]))
  } catch (e) {}
}

// Only the IdP host itself can clear its host-only cookie, so logout asks each one.
export const clearBridgeCookies = async () => {
  const origins = bridgedOrigins()
  try {
    localStorage.removeItem(ORIGINS_KEY)
  } catch (e) {}
  await Promise.all(
    origins.map((origin) => {
      const ctrl = new AbortController()
      const timer = setTimeout(() => ctrl.abort(), CLEAR_TIMEOUT_MS)
      return fetch(origin + '/saml/bridge', {
        method: 'DELETE',
        credentials: 'include',
        signal: ctrl.signal
      })
        .catch(() => {})
        .finally(() => clearTimeout(timer))
    })
  )
}
